import {getAvatars, getExtraGuestsCount} from '@wix/wix-events-commons-statics/dist/members'
import * as React from 'react'
import {AvatarGroup, AvatarGroupSize} from 'wix-ui-tpa/AvatarGroup'
import {isRsvp} from '../../../commons/selectors/event'
import {DH} from '../../utils/data-hooks'
import {MembersProps} from './index'
import s from './members.st.css'

const MAX_AVATARS = 3

export const Members = ({event, t}: MembersProps) => {
  const items = getAvatars(event.members, event.totalGuests, isRsvp(event), MAX_AVATARS)
  const extraGuests = getExtraGuestsCount(event.totalGuests, MAX_AVATARS)
  return (
    <AvatarGroup
      {...{className: s.root}}
      maxAmount={MAX_AVATARS}
      items={items}
      size={AvatarGroupSize.small}
      data-hook={DH.members}
    >
      {extraGuests ? (
        <AvatarGroup.TextButton>{t('members.moreLink', {amount: extraGuests})}</AvatarGroup.TextButton>
      ) : null}
    </AvatarGroup>
  )
}
